<div class="select-body" [class.disabled]="disabled" matAutocompleteOrigin #origin="matAutocompleteOrigin">
  <input
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    [matAutocompleteConnectedTo]="origin"
    [matAutocompleteDisabled]="disabled"
    [ngModel]="''"
    (ngModelChange)="onInputValueChange($event)"
    (blur)="onInputBlur()"
    [disabled]="disabled"
  />

  <svg-icon [name]="'caret-down-outline'"></svg-icon>
</div>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" (closed)="tryUpdateOptions()" [panelWidth]="240">
  @for (option of filteredOptions$ | async; track option) {
    <mat-option [id]="option.id" [value]="option.text" style="width: 240px">
      <svg-icon [name]="'menu-checkmark-on'" *ngIf="option.id === this.selectedId"></svg-icon>
      <svg-icon [name]="'empty-16'" *ngIf="option.id !== this.selectedId"></svg-icon>
      <span class="option-label">{{ option.text }}</span>
    </mat-option>
  }

  <div class="prevent-shift" style="display: none"></div>
</mat-autocomplete>
